import { createRouter, createWebHistory } from 'vue-router'
// import index from '../views/index.vue'

const routes = [
  {
    path: '/PageNotFound',
    name: 'PageNotFound',
    component: () => import(/* webpackChunkName: "about" */ '../views/PageNotFound.vue')
  },
  {
    path: '/:uuid/cp_form',
    name: 'index',
    component: () => import(/* webpackChunkName: "about" */ '../views/index.vue')
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
